// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__T6EA1","approved":"Status_approved__3GkmC","rejected":"Status_rejected__3A-vg","expired":"Status_expired__2CB5I","label":"Status_label__3trXu"};